import mobile from 'is-mobile'

export const convertUrlToMobile = (url: string): string => {
  const separator = window.location.href.includes('temp') ? '-' : '.'

  return url
    .replace('www.', '')
    .replace('https://', `https://m${separator}`)
    .replace('http://', `http://m${separator}`)
}

export const urlHandler = (url: string): string =>
  mobile() ? convertUrlToMobile(url) : url

export const getUrlEnvironment = (): string => {
  const options = [
    ['temp', 'temp'],
    ['fretebras.dev.br', 'stage'],
    ['localhost:3000', 'local'],
    ['www.fretebras.com.br', 'prod'],
    ['m.fretebras.com.br', 'prod_mobile'],
  ]

  const entrie = options.find(([url]) => window.location.href.includes(url))

  return entrie?.[1]
}
